var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade", appear: "" } }, [
    _vm.isOpen
      ? _c(
          "div",
          { staticClass: "cookie fixed w-100 bg-cl-th-accent cl-tertiary" },
          [
            _c("div", { staticClass: "px20" }, [
              _c(
                "div",
                { staticClass: "row coockie-style between-xs middle-xs px15" },
                [
                  _c(
                    "div",
                    { staticClass: "col-xs-10 start-xs" },
                    [
                      _c("cms-block-chunk", {
                        staticClass: "cookie_popup",
                        attrs: { identifier: "c_COOKIES_POPUP" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-xs-2 end-xs" }, [
                    _c(
                      "span",
                      {
                        attrs: { tabindex: "0", role: "button" },
                        on: {
                          click: _vm.accept,
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.accept($event)
                          }
                        }
                      },
                      [
                        _c("cms-block-chunk", {
                          staticClass: "cookie_popup-button",
                          attrs: { identifier: "c_COOKIES_POPUP_BUTTON" }
                        })
                      ],
                      1
                    )
                  ])
                ]
              )
            ])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }